import React from "react";
import PropTypes from "prop-types";
import withStyles from "@mui/styles/withStyles";
import FormControl from "@mui/material/FormControl";
import CircularProgress from "@mui/material/CircularProgress";
import CustomerButton from "../../customer-button/CustomerButton";
const getButtonStyle = buttonOptions => {
  const {
    theme,
    loading,
    disabled,
    staticButton,
    width
  } = buttonOptions;
  let submitButtonEnabledStyle = loading || !disabled ? {
    width: "250px"
  } : {};
  submitButtonEnabledStyle = staticButton ? {
    width: "unset"
  } : submitButtonEnabledStyle;
  const submitButtonStyle = {
    fontSize: theme.typography.fontSize,
    transition: ".25s all",
    display: "flex",
    alignSelf: "center",
    width: width || 205,
    textAlign: "center"
  };
  return {
    ...submitButtonEnabledStyle,
    ...submitButtonStyle
  };
};
const SubmitButton = ({
  classes,
  disabled,
  handleSubmit,
  title,
  loading,
  component,
  containerEnabled = true,
  id,
  staticButton = false,
  theme,
  width
}) => {
  const buttonStyle = React.useMemo(() => getButtonStyle({
    theme,
    loading,
    disabled,
    staticButton,
    width
  }), [theme, loading, disabled, staticButton, width]);
  const handleSubmitClick = () => {
    if (!disabled) {
      handleSubmit();
    }
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    className: containerEnabled ? classes.container : ""
  }, /*#__PURE__*/React.createElement(CustomerButton, {
    variant: "contained",
    onClick: () => handleSubmitClick(),
    disabled: disabled,
    style: buttonStyle,
    component: component ? component : "div",
    id: id,
    className: disabled ? "" : classes.submitButton
  }, title), loading && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 24,
    className: classes.buttonProgress
  }));
};
const styles = theme => {
  var _theme$palette$button, _theme$palette$button2, _theme$palette$button3;
  return {
    container: {
      margin: "10px 25px 10px 25px"
    },
    rightIcon: {
      marginLeft: theme.spacing(1),
      width: "17px"
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
      color: (_theme$palette$button = (_theme$palette$button2 = theme.palette.buttons) === null || _theme$palette$button2 === void 0 ? void 0 : (_theme$palette$button3 = _theme$palette$button2.submit) === null || _theme$palette$button3 === void 0 ? void 0 : _theme$palette$button3.backgroundColor) !== null && _theme$palette$button !== void 0 ? _theme$palette$button : theme.palette.primary.main
    },
    submitButton: {
      "&:focus": {
        border: `1px solid ${theme.palette.primary.dark} !important`
      }
    }
  };
};
SubmitButton.propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  component: PropTypes.string,
  containerEnabled: PropTypes.bool,
  id: PropTypes.string,
  staticButton: PropTypes.bool,
  theme: PropTypes.object,
  width: PropTypes.number
};
export default withStyles(styles, {
  withTheme: true
})(SubmitButton);